import * as React from "react";
import { Theme, useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";

const ITEM_HEIGHT = 32;
const ITEM_PADDING_TOP = 4;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function CommissionSelect({
  options,
  placeholder,
  value,
  handleChange,
}: any) {
  const getSelectedLabel = (selected: string) => {
    for (let index = 0; index < options?.length; index++) {
      if (options[index].value === selected) {
        return options[index].label;
      }
    }
    return "";
  };
  return (
    <div>
      <FormControl sx={{ width: "100%" }}>
        <Select
          sx={{ height: "40px", borderRadius: "10px" }}
          displayEmpty
          defaultValue={value}
          value={value}
          onChange={handleChange}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (!selected) {
              return <span style={{ color: "#999" }}>{placeholder}</span>;
            }
            return getSelectedLabel(selected);
          }}
          MenuProps={MenuProps}
          inputProps={{ "aria-label": "Without label" }}
        >
          <MenuItem disabled value="">
            <em>{placeholder}</em>
          </MenuItem>
          {options.map((option: any) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
